import gql from 'graphql-tag';

const GET_SALESFORCE_ACCOUNT_RECORD_TYPE = gql`
  query GetSalesforceAccountRecordType($salesforceAccountId: String!) {
    getSalesforceAccountRecordType(salesforceAccountId: $salesforceAccountId)
  }
`;

export default GET_SALESFORCE_ACCOUNT_RECORD_TYPE;
